import React, { useState } from "react";

export function IndicadorComSetas(props) {
    const [hoverVoltar, setHoverVoltar] = useState(false);
    const [hoverAvancar, setHoverAvancar] = useState(false);
    if (!props.visivel) return null;

    const estilo = {
        fontWeight: "bold",
        borderRadius: "100%",
        color: "#FFF",
        display: "flex",
        alignItems: "center",
    };

    return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <button
                disabled={props.desabilitarVoltar}
                className="btn"
                style={{ ...estilo, color: hoverVoltar ? "#ff1e6e" : props.cor }}
                onClick={() => {
                    props.handleVoltar();
                    setHoverAvancar(false);
                }}
                onMouseEnter={() => setHoverVoltar(true)}
                onMouseLeave={() => setHoverVoltar(false)}
            >
                <i className="fas fa-caret-left" style={{ fontSize: "2rem" }} />
            </button>

            <div style={{ ...estilo, height: 40 }}>
                {props.titulo ? <span style={{ fontSize: "1.4rem" }}>{props.titulo}</span> : <i className="fas fa-sort-down" style={{ fontSize: "4.8rem", lineHeight: 20 }} />}
            </div>
            <button
                disabled={props.desabilitarAvancar}
                className="btn"
                style={{ ...estilo, color: hoverAvancar ? "#ff1e6e" : props.cor }}
                onClick={() => {
                    props.handleAvancar();
                    setHoverAvancar(false);
                }}
                onMouseEnter={() => setHoverAvancar(true)}
                onMouseLeave={() => setHoverAvancar(false)}
            >
                <i className="fas fa-caret-right" style={{ fontSize: "2rem" }} />
            </button>
        </div>
    );
}
